// Shared styled-component primitives for /pages/* sorbet-themed pages
// (e.g. /pages/tax-id, /pages/vat-consumer-self-cert).
//
// Only the components below are byte-identical between consumers. Page-level
// surfaces that intentionally differ — `SorbetCard`, `Title`, `Message`,
// `InfoMessage` — are defined locally in each page so per-page spacing and
// layout choices stay isolated.
import styled from "styled-components/macro";
import SudowriteLogo from "../SudowriteLogo";

export const Logo = styled(SudowriteLogo).attrs({ size: "large" })`
  display: block;
  margin: 0 auto 24px;
`;

export const ContentWrapper = styled.div`
  width: 100%;
  max-width: 600px;
`;

export const BackArrow = styled.span`
  display: inline-block;
  width: 8px;
  height: 8px;
  border-left: 2px solid currentColor;
  border-bottom: 2px solid currentColor;
  transform: rotate(45deg);
`;

export const BackButton = styled.a`
  position: absolute;
  top: 24px;
  left: 24px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  color: var(--grey-1, #686868);
  text-decoration: none;
  padding: 4px 0;
  transition-property: color;
  transition-duration: 0.2s;

  &:hover {
    color: var(--grey-0, #383838);
  }
`;

export const PageWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 60px 20px;
  background: transparent;
`;

export const ErrorMessage = styled.p`
  font-size: 14px;
  color: var(--danger-color);
  background: var(--danger-color-hover);
  border-radius: 10px;
  padding: 10px 14px;
  margin: 0;
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const FieldLabel = styled.label`
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: var(--grey-0, #383838);
  margin: 0;
`;

export const EmailValue = styled.span`
  font-size: 15px;
  color: var(--grey-0, #383838);
`;
